<template>
  <button type="button" :disabled="loading" @click="toggle"><span><font-awesome-icon :icon="microphone"/></span></button>
</template>

<script>
import api from './../http'
import moment from 'moment'

export default {
  props: {
    textArea: {
      type: HTMLTextAreaElement
    },
    forceStop: {
      type: Boolean
    }
  },
  data: function () {
    return {
      loading: false,
      stream: null,
      tokenUrl: '/api/v1/speech-to-text/token',
      logUrl: '/api/v1/speech-to-text/log',
      startTime: null,
      recognizeMicrophone: null
    }
  },
  computed: {
    microphone () {
      if (this.loading === true) {
        return 'spinner'
      }
      return this.stream !== null ? 'microphone-slash' : 'microphone'
    }
  },
  methods: {
    toggle () {
      if (this.stream) {
        this.stop()
      } else {
        this.record()
      }
    },

    record () {
      this.$emit('startRecording')
      let self = this
      self.loading = true
      self.startTime = moment()
      api.makeRequest(this.tokenUrl).then((data) => {
        self.stream = self.recognizeMicrophone({
          access_token: data.data.accessToken,
          outputElement: self.textArea,
          smart_formatting: true
        })

        self.loading = false
        setTimeout(self.autoStop, 60000)

        self.stream.on('error', function (err) {
          console.log(err)
          self.stop()
          self.loading = false
        })
      }
      )
    },

    stop () {
      if (this.stream) {
        var seconds = moment.duration(moment().diff(this.startTime)).seconds()
        let self = this

        api.postRequest(self.logUrl,
          {
            duration: seconds
          }
        )
        this.stream.stop()
        this.$emit('stopRecording')
      }
      this.stream = null
    },

    autoStop () {
      if (moment.duration(moment().diff(this.startTime)).seconds() === 60) {
        this.stop()
      }
    }
  },
  created () {
    this.recognizeMicrophone = require('watson-speech/speech-to-text/recognize-microphone')
  },
  watch: {
    forceStop: function () {
      if (this.forceStop) {
        this.stop()
      }
    }
  }
}
</script>
